import { gql } from '@apollo/client';

const GET_MDDAP_PRACTICE_GROUPS = gql`
  query GetMddapPracticeGroups {
    mddapPracticeGroups {
      Id
      Level
      Practices {
        Id
        NumberWithinLevel
      }
    }
  }
`;

export default GET_MDDAP_PRACTICE_GROUPS;
